import unescapedText from 'I18n/utils/unescapedText';
const CALL_SOURCE_LABEL_KEY = {
  GOOGLE_MEET: 'external-sharing-components.meetingDetails.callSource.googleMeet',
  ZOOM: 'external-sharing-components.meetingDetails.callSource.zoom',
  MICROSOFT_TEAMS: 'external-sharing-components.meetingDetails.callSource.microsoftTeams',
  HUBSPOT_MEETINGS: 'external-sharing-components.meetingDetails.callSource.hubspotMeetings'
};
export const getCallSourceLabel = callSource => {
  if (!callSource) return null;
  const key = CALL_SOURCE_LABEL_KEY[callSource];
  if (!key) return null;
  return unescapedText(key);
};